<template>
  <div class="album-card" @click="$emit('select', album)">
    <img :src="album.cover" :alt="album.title" />
    <h3>{{ album.title }}</h3>
    <p class="year">{{ album.year }}</p>
  </div>
</template>

<script>
export default {
  name: 'AlbumCard',
  props: {
    album: Object,
  },
};
</script>

<style scoped>
.album-card {
  background: #1a1a1a;
  border-radius: 10px;
  padding: 1.5rem;
  max-width: 300px;
  color: #eee;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.6);
  transition: transform 0.3s;
  cursor: pointer;
}
.album-card:hover {
  transform: scale(1.03);
}
.album-card img {
  width: 100%;
  border-radius: 6px;
  margin-bottom: 1rem;
}
.album-card h3 {
  margin: 0.5rem 0;
  font-size: 1.5rem;
  color: #fff;
}
.album-card .year {
  font-size: 1rem;
  color: #999;
}
</style>
